import '../../assets/css/after event/List Of Winner Detail.css'
import ListOfWinnerDetail2024Comp from '../../components/after event/ListOfWinnerDetail2024Comp'

const ListOfWinnerDetail2024Page = () =>{
    return(
        <>
        <ListOfWinnerDetail2024Comp></ListOfWinnerDetail2024Comp>
        </>
    )
}

export default ListOfWinnerDetail2024Page